import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-lr-plus',
  templateUrl: './header-lr-plus.component.html',
  styleUrls: ['./header-lr-plus.component.scss']
})
export class HeaderLrPlusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
